module.exports = __webpack_public_path__ + "img/jp-cover.ca5c5a33.png";